import type { Entries } from '.'

export const objectEntries: <T extends object>(obj: T) => Entries<T> = Object.entries
